import { PlusIcon } from "@heroicons/react/24/outline";
import { useRouteLoaderData } from "react-router";
import posthog from "posthog-js";
import { $routeId } from "safe-routes";
import { useState } from "react";

import { TemplateCard } from "~/components/TemplateCard";
import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/components/ui/dialog";
import { useSidebar } from "~/components/ui/sidebar";
import trackingEvents from "~/lib/trackingEvents";
import type { Template } from "~/models/templates.server";

export function NewNotebookModal() {
  const rootData = useRouteLoaderData<{ templates: Template[] }>($routeId("root"));
  const templates = rootData?.templates || [];
  const sidebar = useSidebar();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {sidebar.state === "expanded" ? (
          <Button variant="outline" className="w-full mb-2">
            <PlusIcon className="w-4 h-4 mr-1" />
            <span>New Notebook</span>
          </Button>
        ) : (
          <Button variant="outline" className="w-full px-1 py-2 h-auto">
            <PlusIcon className="w-4 h-4" />
          </Button>
        )}
      </DialogTrigger>
      <DialogContent aria-describedby={undefined} className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Create a new notebook by selecting a template below.</DialogTitle>
        </DialogHeader>
        <div className="flex flex-wrap gap-8 mt-4 justify-center">
          {templates.map((template) => (
            <TemplateCard
              key={template.id}
              notebook={template}
              onSubmit={() => {
                posthog.capture(trackingEvents.cta_click_choose_template, {
                  notebook_id: template.id,
                });
                setIsOpen(false);
              }}
            />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
